import React, {useState} from 'react'
import {JSONFetcher} from 'shared'

export const SubscriptionToggle = (props) => {
  const id = `subscription-toggle-${props.id}`
  const [value, setValue] = useState(props.initialValue === 'true')
  const handleChange = () => {
    JSONFetcher.put({
      url: props.url,
      jsonObject: { mailing_subscription: { active: !value } },
      success: (response) => {
        if (response.success) {
          setValue(!value)
        }
      }
    })
  }

  return <form className='simpleform simple_form edit_mailing_subscription'>
    <div className='generic-toggle-button small'>
      <label htmlFor={id} className='checkbox toggle candy'>
        <input id={id} type='checkbox' value='1' checked={value} onChange={handleChange} />
        <p>
          <span>{{en: 'Yes', de: 'Ja'}[I18n.locale]}</span>
          <span>{{en: 'No', de: 'Nein'}[I18n.locale]}</span>
        </p>
        <a className='btn btn-primary slide-button' />
      </label>
    </div>
  </form>
}
